import { render, staticRenderFns } from "./PhaseDialog.vue?vue&type=template&id=1f3c9e7c&scoped=true&"
import script from "./PhaseDialog.vue?vue&type=script&lang=js&"
export * from "./PhaseDialog.vue?vue&type=script&lang=js&"
import style0 from "./PhaseDialog.vue?vue&type=style&index=0&id=1f3c9e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3c9e7c",
  null
  
)

export default component.exports